import Permissions from './Permissions';

const UserCan = permissions => permission => permissions.indexOf(permission) !== -1
  || permissions.indexOf(Permissions.all) !== -1;

export default UserCan;
